import { Sparkles } from "lucide-react";

export const FIELD_META = {
  date: { label: "Tarikh", color: "#3b82f6" },
  time: { label: "Masa", color: "#06b6d4" },
  station_name: { label: "Stesen", color: "#8b5cf6" },
  fuel_type: { label: "Jenis Minyak", color: "#f59e0b" },
  liters: { label: "Liter", color: "#10b981" },
  price_per_liter: { label: "Harga/L", color: "#ec4899" },
  amount_rm: { label: "Jumlah RM", color: "#ef4444" },
  used_budi: { label: "Subsidi BUDI", color: "#198754" },
  payment: { label: "Bayaran", color: "#64748b" },
};

export function AiBadge() {
  return (
    <span className="inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-full px-1.5 py-0.5 ml-1.5">
      <Sparkles className="h-2.5 w-2.5" /> AI
    </span>
  );
}

export function ReceiptOverlay({ image, fields, activeField, onPickField }) {
  return (
    <div className="space-y-3">
      <div className="relative rounded-xl overflow-hidden border shadow-sm bg-slate-900" data-testid="receipt-overlay">
        <img src={image} alt="Resit" className="w-full block" />
        {fields && Object.entries(FIELD_META).map(([key, meta]) => {
          const f = fields[key];
          if (!f || !f.box || f.value === null || f.value === undefined) return null;
          const [y1, x1, y2, x2] = f.box;
          const dimmed = activeField && activeField !== key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onPickField?.(key)}
              data-testid={`receipt-highlight-${key}`}
              title={`${meta.label}: ${f.value}`}
              className="absolute rounded-sm transition-all duration-200"
              style={{
                top: `${y1 / 10}%`, left: `${x1 / 10}%`,
                height: `${Math.max(y2 - y1, 14) / 10}%`, width: `${Math.max(x2 - x1, 30) / 10}%`,
                border: `2px solid ${meta.color}`,
                background: `${meta.color}${activeField === key ? "3d" : "1f"}`,
                opacity: dimmed ? 0.18 : 1,
                boxShadow: activeField === key ? `0 0 0 3px ${meta.color}55, 0 0 12px ${meta.color}88` : "none",
                zIndex: activeField === key ? 20 : 10,
              }}
            >
              <span
                className="absolute -top-4 left-0 text-[8px] font-bold text-white px-1 py-px rounded-sm whitespace-nowrap transition-opacity"
                style={{ background: meta.color, opacity: activeField === key ? 1 : 0 }}
              >
                {meta.label}
              </span>
            </button>
          );
        })}
      </div>
      {fields && (
        <div className="flex flex-wrap gap-1.5" data-testid="receipt-legend">
          {Object.entries(FIELD_META).map(([key, meta]) => {
            const f = fields[key];
            if (!f || f.value === null || f.value === undefined) return null;
            return (
              <button key={key} type="button" onClick={() => onPickField?.(key)}
                data-testid={`legend-${key}`}
                className={`text-[10px] font-semibold rounded-full px-2 py-1 border transition-all ${activeField === key ? "text-white shadow" : "bg-white"}`}
                style={{ borderColor: meta.color, color: activeField === key ? "#fff" : meta.color, background: activeField === key ? meta.color : "#fff" }}>
                {meta.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
